/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddAccountRequest as ModelsV3LoanManagementAddAccountRequest } from '../../models/Models/v3/LoanManagement/add-account-request';

export interface V3LoanManagementAccountsPost$Xml$Xml$Params {
      body?: ModelsV3LoanManagementAddAccountRequest
}

export function v3LoanManagementAccountsPost$Xml$Xml(http: HttpClient, rootUrl: string, params?: V3LoanManagementAccountsPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementAccountsPost$Xml$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementAddAccountRequest>;
    })
  );
}

v3LoanManagementAccountsPost$Xml$Xml.PATH = '/v3/loan-management/accounts';
